export default __webpack_public_path__ + "static/media/plus.8f3ab9f7.svg";